import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
};

export type ContactUs = {
  text: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ContactUsOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export enum GeneralStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
}

export enum GeneralStatusAdmin {
  Deleted = 'DELETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
}

export type Mutation = {
  contactUs?: Maybe<ContactUsOutput>;
};

export type MutationContactUsArgs = {
  data: ContactUs;
};

export type NumberFilterOptions = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};

export enum Order {
  Asc = 'asc',
  Desc = 'desc',
}

export type Query = {
  ping?: Maybe<Scalars['String']['output']>;
};

export type StringFilterOptions = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type ContactUsMutationVariables = Exact<{
  data: ContactUs;
}>;

export type ContactUsMutation = {
  contactUs?: { message?: string | null; statusCode?: number | null } | null;
};

export const ContactUsDocument = gql`
  mutation contactUs($data: ContactUs!) {
    contactUs(data: $data) {
      message
      statusCode
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ContactUsMutationService extends Apollo.Mutation<
  ContactUsMutation,
  ContactUsMutationVariables
> {
  override document = ContactUsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
